import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { IVehicleApi } from "./base";
import { VehicleAutoCompleteResponse } from "@/main/models/response";
import { PaginationResponse } from "../models/common/paginationResponse";
import { VehicleAutocompleteFilterRequest } from "../models/request";

const baseRoute: string = "Vehicle";

export class VehicleApi extends IVehicleApi {
	private activeAbortControllerAutocompletePartial: AbortController | null = null;
	private activeAbortControllerAutocompleteFull: AbortController | null = null;

	async getVehicleAutocompletePartial(
		request: VehicleAutocompleteFilterRequest,
		cancelRequest: boolean = true,
	): Promise<AxiosResponse<PaginationResponse<VehicleAutoCompleteResponse>>> {
		if (!cancelRequest) {
			return await api.get(`${baseRoute}/GetVehicleAutocompleteParcial`, {
				params: request,
			});
		}
		// Notation: Control of the same request being made multiple times, considering the last one executed
		if (this.activeAbortControllerAutocompletePartial) {
			this.activeAbortControllerAutocompletePartial.abort();
		}
		this.activeAbortControllerAutocompletePartial = new AbortController();
		const response = await api.get(`${baseRoute}/GetVehicleAutocompleteParcial`, {
			params: request,
			signal: this.activeAbortControllerAutocompletePartial.signal,
		});
		this.activeAbortControllerAutocompletePartial = null;
		return response;
	}

	async getVehicleAutocompleteFullWithYear(
		request: VehicleAutocompleteFilterRequest,
		cancelRequest: boolean = false,
	): Promise<AxiosResponse<PaginationResponse<VehicleAutoCompleteResponse>>> {
		if (!cancelRequest) {
			return await api.get(`${baseRoute}/GetVehicleAutocompleteFullWithYear`, {
				params: request,
			});
		}
		// Notation: Control of the same request being made multiple times, considering the last one executed
		if (this.activeAbortControllerAutocompleteFull) {
			this.activeAbortControllerAutocompleteFull.abort();
		}
		this.activeAbortControllerAutocompleteFull = new AbortController();
		const response = await api.get(`${baseRoute}/GetVehicleAutocompleteFullWithYear`, {
			params: request,
			signal: this.activeAbortControllerAutocompleteFull.signal,
		});
		this.activeAbortControllerAutocompleteFull = null;
		return response;
	}
}
